import React, { Component } from 'react'
import SchoolListComponent from "./SchoolListComponent"
import {connect} from "react-redux"
import {SchoolInformationActions} from "../../../store";


class SchoolListContainer extends Component {
    render() {
        return <SchoolListComponent {...this.props}/>
        
    }
}
const mapDispatchToProps=(dispatch ,ownProps)=>( {   
    
    deleteSchoolInformation: (list)=> dispatch(SchoolInformationActions.deleteSchoolInformation(list))
}
)


export default connect(null,mapDispatchToProps) (SchoolListContainer);